import { Flex, Text } from "@chakra-ui/react";
import DashboardPrevisaoOrcamentaria from "./Components/Dashboard/index";
import Container from "components/Container";
import CollapsePlanejamento from "./Components/CollapsePlanejamento/index";
import { useState, useEffect } from "react";
import { showConfirm } from "infra/helpers/alerta";
import useDeleteCategoriaPrevisaoOrcamentaria from "core/features/previsao-orcamentaria/hooks/useDeleteCategporiaPrevisaoOrcamentaria ";
import { PlanejamentoOrcamentarioDetalheItemResponse } from "core/features/previsao-orcamentaria/typings";
import { useParams } from "react-router-dom";
import PrimaryButton from "components/Button/PrimaryButton";
import PageHeader from "components/Page/PageHeader/index";
import ModalLancamentoPrevisaoOrcamentaria from "ui/components/PrevisaoOrcamentaria/ModalLancamentoPrevisaoOrcamentaria";
import { useBreadcrumb } from "core/features/breadcrumbs/index";
import FiltroPeriodo from "ui/components/PrevisaoOrcamentaria/FiltroPeriodo/index";
import useDetalhesExecucaoOrcamentaria from "core/features/execucao-orcamentaria/hook/useDetalhesExecucaoOrcamentaria";
import { FiltroPrevisaoOrcamentaria } from "core/features/previsao-orcamentaria/typings";
import { useLoading } from "ui/components/GlobalLoading";
import useAtualizarLancamentoMes from "core/features/previsao-orcamentaria/hooks/useAtualizarLancamentoMes";
import { FaFilter } from "react-icons/fa";
import { AiOutlinePlus } from "react-icons/ai";
import ModalFiltrosExecucaoOrcamentaria from "./Components/ModalFiltros/index";

export default function DetalhesExecucaoOrcamentaria() {
  const { id } = useParams() as { id: string };

  const [filtro, setFiltro] = useState<FiltroPrevisaoOrcamentaria>({
    mes: undefined,
    media: undefined,
    centrosDeCustoIds: undefined,
    categoriasFinanceirasIds: undefined,
  });

  const { data, isLoading, isFetching, refetch } =
    useDetalhesExecucaoOrcamentaria(id, filtro);

  useBreadcrumb([
    { name: "Financeiro" },
    {
      name: "Execução Orçamentária",
      url: "/financeiro/execucao-orcamentaria",
    },
    {
      name: data
        ? `Execução da previsão ${data?.nome}`
        : `Execução Orçamentária`,
    },
  ]);

  const [editItem, setEditItem] = useState<
    PlanejamentoOrcamentarioDetalheItemResponse | undefined
  >();

  const [isOpenModalLancamento, setIsOpenModalLancamento] = useState(false);
  const [isOpenModalFiltros, setIsOpenModalFiltros] = useState(false);

  const { mutate: handleDeleteCategoria, isLoading: isLoadingDelete } =
    useDeleteCategoriaPrevisaoOrcamentaria();

  const handleDelete = async (categoriaId: string) => {
    const { isConfirmed } = await showConfirm();
    if (isConfirmed) {
      handleDeleteCategoria(
        { categoriaId, id, mes: filtro?.mes },
        { onSuccess: () => refetch() }
      );
    }
  };

  const { mutate: atualizarLancamentoMes, isLoading: isLoadingAtualizarMes } =
    useAtualizarLancamentoMes({
      id,
      mes: filtro?.mes,
    });

  const onEditItem = (item: PlanejamentoOrcamentarioDetalheItemResponse) => {
    setEditItem(item);
  };

  const onChangeFiltro = (filtro: Partial<FiltroPrevisaoOrcamentaria>) => {
    setFiltro((state) => ({ ...state, ...filtro }));
  };

  useLoading(
    isLoadingDelete || isLoading || isFetching || isLoadingAtualizarMes
  );

  const onEditMes = (valor: number, categoriaFinanceiraId: string) => {
    atualizarLancamentoMes(
      {
        valor,
        categoriaFinanceiraId,
      },
      {
        onSuccess: () => refetch(),
      }
    );
  };

  useEffect(() => {
    if (editItem) {
      setIsOpenModalLancamento(true);
    }
  }, [editItem]);

  useEffect(() => {
    if (!isOpenModalLancamento) {
      setEditItem(undefined);
    }
  }, [isOpenModalLancamento]);

  return (
    <Container overflowX="hidden">
      <PageHeader
        title={
          data ? `Execução da previsão ${data?.nome}` : `Execução Orçamentária`
        }
        extraButtonTitle="Mais filtros"
        extraButtonOnClick={() => {
          setIsOpenModalFiltros(true);
        }}
        badge={
          !!filtro?.centrosDeCustoIds?.length ||
          !!filtro?.categoriasFinanceirasIds?.length
        }
        badgeValueExtraButton={
          (filtro?.centrosDeCustoIds?.length ? 1 : 0) +
          (filtro?.categoriasFinanceirasIds?.length ? 1 : 0)
        }
        iconExtraButton={
          <>
            <FaFilter size={14} />
            <Flex right="10px" top="14px" position="absolute">
              <AiOutlinePlus size={9} />
            </Flex>
          </>
        }
      />

      <FiltroPeriodo
        showMediaMensal
        filtro={filtro}
        onChangeFiltro={onChangeFiltro}
      />

      <DashboardPrevisaoOrcamentaria
        data={data}
        isLoading={isLoading}
        isFetching={isFetching}
      />

      <Flex
        flexDir="column"
        overflow="auto"
        maxW="100vw"
        className="custom-scroll-bar"
        pb="10px"
        position="relative"
      >
        <Flex mb={6} justify="space-between" wrap="wrap" rowGap={6}>
          <Flex gap={6} align="center" position="sticky" top={0} left={0}>
            <Text fontSize="22px" fontWeight="bold">
              Planejamento
            </Text>
            <PrimaryButton
              py={1}
              onClick={() => setIsOpenModalLancamento(true)}
            >
              Adicionar lançamento
            </PrimaryButton>
          </Flex>

          <Flex
            fontWeight="medium"
            justifyContent="flex-end"
            pl="300px"
            minW="720px"
            flex={1}
            mb={4}
            gap={4}
            pr={"72px"}
          >
            <Flex minW="150px" justifyContent="flex-end">
              <Text align="end" fontSize="16px">
                Previsto
              </Text>
            </Flex>
            <Flex minW="150px" justifyContent="flex-end">
              <Text align="end" fontSize="16px">
                Realizado
              </Text>
            </Flex>
            <Flex minW="150px" justifyContent="flex-end">
              <Text align="end" fontSize="16px">
                Resultado
              </Text>
            </Flex>
          </Flex>
        </Flex>

        <Flex flexDir="column" gap={4} minW="720px">
          {data?.receitas.map((item) => (
            <Flex>
              <CollapsePlanejamento
                filtro={filtro}
                onEdit={onEditItem}
                onEditMes={onEditMes}
                handleDelete={handleDelete}
                item={item}
              />
            </Flex>
          ))}

          {data?.despesas.map((item) => (
            <CollapsePlanejamento
              filtro={filtro}
              onEdit={onEditItem}
              onEditMes={onEditMes}
              handleDelete={handleDelete}
              item={item}
            />
          ))}
        </Flex>
      </Flex>

      <ModalLancamentoPrevisaoOrcamentaria
        dataInicioPrevisao={data?.dataInicio}
        onClose={() => setIsOpenModalLancamento(false)}
        visible={isOpenModalLancamento}
        previsaoId={id}
        data={editItem}
        refetch={refetch}
      />

      {isOpenModalFiltros ? (
        <ModalFiltrosExecucaoOrcamentaria
          onClose={() => setIsOpenModalFiltros(false)}
          filtro={filtro}
          isOpenModal={isOpenModalFiltros}
          onChangeFiltro={setFiltro}
        />
      ) : null}
    </Container>
  );
}
